/**
 * Created by Administrator on 2019/2/14.
 */
import active from '@/components/active'
import routerView from '@/globalComponent/routerView'
export default
// {
  // path:'/active',
  // name:'active',
  // component:routerView.Content,
  // redirect: '/active/list',
  // children:
    [
    {
      path:'/active/list',
      name:'activeList',
      component:active.activeList,
      meta:{
        title:'活动列表',
        keepAlive:false
      }
    },{
      path:'/active/apply',
      name:'activeApply',
      component:active.activeApply,
      meta:{
        title:'活动申请'
      }
    },{
      path:'/active/reportList',
      name:'activeReportList',
      component:active.activeReportList,
      meta:{
        title:'活动报告列表',
        keepAlive:false
      }
    },{
      path:'/active/activeApprove',
      name:'activeApprove',
      component:active.activeApprove,
      meta:{
        title:'活动审批'
      }
    },{
      path:'/active/activeDetail',
      name:'activeDetail',
      component:active.activeDetail,
      meta:{
        title:'活动详情'
      }
    },{
      path:'/active/reportApply',
      name:'reportApply',
      component:active.reportApply,
      meta:{
        title:'活动报告申请'
      }
    },{
      path:'/active/reportDetail',
      name:'reportDetail',
      component:active.reportDetail,
      meta:{
        title:'活动报告详情'
      }
    },{
      path:'/active/reportApprove',
      name:'reportApprove',
      component:active.reportApprove,
      meta:{
        title:'活动报告审批'
      }
    },{
      path:'/active/activeRemark',
      name:'activeRemark',
      component:active.activeRemark,
      meta:{
        title:'活动作品点评'
      }
    }
  ]
// }



// WEBPACK FOOTER //
// ./src/router/active.js